import { sortBy } from '@vrplatform/utils';

export type TrustReconcilationListingSorting = 'name' | 'centTotal';

export type SortableTrustReconcilationListingRow = {
  id: string;
  name: string;
  centTotal: number;
};

export const sortTrustReconcilationListingRows = <
  TRow extends SortableTrustReconcilationListingRow,
>(
  rows: TRow[],
  sorting: TrustReconcilationListingSorting,
  options?: {
    pinUnassignedListingFirst?: boolean;
  }
) => {
  const direction = sorting === 'centTotal' ? 'desc' : 'asc';
  const sortedRows = sortBy(rows, sorting, direction);

  if (!options?.pinUnassignedListingFirst) {
    return sortedRows;
  }

  const unassignedRows: TRow[] = [];
  const assignedRows: TRow[] = [];

  for (const row of sortedRows) {
    const normalizedId = row.id.trim().toLowerCase();
    const normalizedName = row.name.trim().toLowerCase();
    const isUnassignedListing =
      normalizedId === 'unassigned' ||
      normalizedName === 'unassigned' ||
      normalizedName === 'unassigned listing';

    if (isUnassignedListing) {
      unassignedRows.push(row);
      continue;
    }

    assignedRows.push(row);
  }

  if (unassignedRows.length === 0) {
    return sortedRows;
  }

  return [...unassignedRows, ...assignedRows];
};
